import React from "react";

const DateSelector = ({ selectedDate, setSelectedDate }) => {
	return (
		<div style={{
			display: "flex",
			alignItems: "center",
			gap: "8px",
			padding: "10px 16px",
			backgroundColor: "white",
			border: "2px solid #E5E7EB",
			borderRadius: "8px",
		}}>
			<span style={{ fontSize: "16px" }}>📅</span>
			<input
				type="date"
				value={selectedDate || ""}
				onChange={(e) => setSelectedDate(e.target.value)}
				max={new Date().toISOString().split('T')[0]}
				style={{
					border: "none",
					outline: "none",
					fontSize: "14px",
					fontWeight: "600",
					color: "#1F2937",
					cursor: "pointer"
				}}
			/>
		</div>
	);
};

export default DateSelector;